import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=d0e9afac&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0e9afac')) {
      api.createRecord('d0e9afac', component.options)
    } else {
      api.reload('d0e9afac', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=d0e9afac&", function () {
      api.rerender('d0e9afac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/user/ResetPassword.vue"
export default component.exports